export enum IconType {
  PLUS = "plus",
  ARROW_LEFT = "arrow-left",
  ARROW_LEFT_LARGE = "arrow-left-l",
  ARROW_RIGHT = "arrow-right",
  ARROW_RIGHT_LARGE = "arrow-right-l",
  ARROW_DOWN = "arrow-down",
  ARROW_UP = "arrow-up",
  ARROW_LINK = "arrow-link",
  CLOSE = "close",
  CHEVRON_DOWN = "chevron-down",
  CHEVRON_LEFT = "chevron-left",
  CHEVRON_RIGHT = "chevron-right",
  FILE_COPY = "file-copy",
  ICON_LOADING = "icon-loading",
  ICON_WAREHOUSE = "icon-warehouse",
  ICON_NETWORK = "icon-network",
  ICON_ZIPS = "icon-zips",
  ICON_DELIVERY = "icon-delivery",
  PLAY = "play",
  PLAY_WHITE = "play-white",
  PAUSE = "pause",
  TWITTER = "twitter",
  LINKEDIN = "linkedin",
  MEDIUM = "medium",
  INSTAGRAM = "instagram",
  STORMY = "stormy",
  SUNNY = "sunny",
  PODCAST = "podcast",
}

export enum ButtonColor {
  RED = "red",
  GRAY = "gray",
  BLACK = "black",
  BLACK_WITH_ICON = "black-with-icon",
  WHITE = "white",
  WHITE_LIGHT = "white-light",
  WHITE_FADED = "white-faded",
  WHITE_FADED_LIGHT = "white-faded-light",
  DARK_LIGHT = "dark-light",
  DARK_GREEN = "dark-green",
  GREEN = "green",
  SAND = "sand",
  YELLOW = "yellow",
  BLUE = "blue",
}

export type StoryblokPostPreview = {
  name: string;
  full_slug: string;
  post_date: string;
  content: {
    author?: string;
    topic?: {
      name: string;
    };
    mastheadImage: {
      filename: string;
      alt: string;
    };
    externalLink?: {
      url: string;
    };
    topics?: string[];
    industries?: string[];
    previewHeading?: string;
    previewTeaser?: string;
  };
};
